module.exports = __webpack_public_path__ + "img/loading-image.0836a709.gif";